import IconRightArrow from '@atoms/IconRightArrow';
import { FontAwesome } from '@expo/vector-icons';
import appStyles from '@root/appStyles';
import { COMMON_CONSTANTS } from '@root/constants';
import colors from '@theme/colors';
import { View, Text, Divider } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Linking, TouchableOpacity } from 'react-native';
import logoutWhatsapp from './analyticsWhatsapp';
import styles from './styles';

function ProfileWhatsapp({ isPIC }) {
  const { t } = useTranslation('common');
  const onSupportPressHandler = () => {
    logoutWhatsapp(isPIC);
    Linking.openURL(COMMON_CONSTANTS.support);
  };
  return (
    <TouchableOpacity testID="btnProfileWhatsapp" onPress={onSupportPressHandler}>
      <View style={appStyles.marginLeft(16)} marginY="16px">
        <Text testID="txtProfileWAHeader" variant="md-bold">
          {t('profile.bantuanHeader')}
        </Text>
        <View flexDirection="row" marginTop="16px" alignItems="center">
          <View backgroundColor={colors.success.softCactus} padding="7px" borderRadius="12px" justifyContent="center">
            <FontAwesome name="whatsapp" size={18} color="green" style={styles.whatsappStyles} />
          </View>
          <Text testID="txtCustomerService" variant="md-normal" marginLeft="8px" flex={1}>
            {t('profile.customerService')}
          </Text>
          <IconRightArrow />
        </View>
      </View>
      <Divider height="4px" style={{ backgroundColor: colors.neutral.mist }} />
    </TouchableOpacity>
  );
}

ProfileWhatsapp.propTypes = {
  isPIC: PropTypes.bool.isRequired,
};

export default ProfileWhatsapp;
